

const TextType = () => {
    return ""
}

export default TextType;